import styled from "styled-components";
export const AppContainer = styled.div`
    background: radial-gradient(
        circle,
        rgba(255, 233, 239, 1) 0%,
        rgba(255, 255, 255, 1) 50%
    );
    padding: 0;
    margin: 0;
    min-height: 90vh;
`;
